export default __webpack_public_path__ + "static/media/Beardhemian Brushsody.c0997bf7.png";